import type { ChangeEvent } from 'react'
import { PatientUser } from '~/shared/types'
import { Box, Button, TextField, Typography } from '@mui/material'
import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useProgramEnrollmentEvent } from '../ProgramTabService'
import { FFModal } from '~/shared/ui'
import { PRIMARY_CARE_PROGRAM_UID, ProgramEnrollmentEvents } from '~/entities/program'
import { queueNotification } from '~/shared/notifications/actions'

interface EstablishMemberModalProps {
  patient: PatientUser
  handleClose: () => void
  open: boolean
}

const EstablishMemberModal: FC<EstablishMemberModalProps> = props => {
  const dispatch = useDispatch()
  const date = new Date()
  const [enrollmentDate, setEnrollmentDate] = useState<string>(
    `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`,
  )
  const { mutateAsync: handleEnrollmentEvent } = useProgramEnrollmentEvent()
  const handleTextInputSelection = (event: ChangeEvent<HTMLInputElement>) => {
    const dateStr: string = event.target.value
    setEnrollmentDate(dateStr)
  }
  const handleEstablishment = async () => {
    try {
      // add patient to new enrollment
      await handleEnrollmentEvent({
        uid: PRIMARY_CARE_PROGRAM_UID,
        event: ProgramEnrollmentEvents.CARE_ESTABLISHED,
        person_id: props.patient.person.id,
        event_date: enrollmentDate,
      })
      props.handleClose()
    } catch (e: unknown) {
      const err = e as { data?: { error?: string } }
      const errorMessage = err?.data?.error || `Failed to establish member`
      dispatch(queueNotification({ variant: 'error', message: errorMessage }))
    }
  }

  return (
    <FFModal open={props.open} style={{ width: '60%' }}>
      <Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3, ml: 4 }}>
          <Typography variant="h6">Establish Member in Primary Care</Typography>
          <Box sx={{ mt: 4 }}>
            <TextField
              value={enrollmentDate}
              onChange={handleTextInputSelection}
              label={'Establishment Date'}
              variant="outlined"
              style={{ width: '70%' }}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 4, py: 4 }}>
          <Box sx={{ mr: 1 }}>
            <Button disabled={false} onClick={props.handleClose} color="primary">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={false}
              variant="contained"
              color="primary"
              onClick={() => void handleEstablishment()}
            >
              Establish
            </Button>
          </Box>
        </Box>
      </Box>
    </FFModal>
  )
}

export default EstablishMemberModal
